import React from 'react';
interface BillTotalsProps {
  subtotalEOAmount: number;
  matchedAmount: number;
  totalDueAmount: number;
  outstandingAmount: number;
}
export function BillTotals({
  subtotalEOAmount,
  matchedAmount,
  totalDueAmount,
  outstandingAmount
}: BillTotalsProps) {
  const formatCurrency = (amount: number) => {
    return `$${amount.toFixed(2)}`;
  };
  return <div className="flex justify-end mb-8" data-id="element-159">
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-6 min-w-[360px] shadow-sm" data-id="element-160">
        <div className="space-y-3" data-id="element-161">
          <div className="flex justify-between items-center" data-id="element-162">
            <span className="text-sm font-medium text-neutral-600" data-id="element-163">
              Subtotal EO Amount:
            </span>
            <span className="text-sm text-neutral-900 tabular-nums" data-id="element-164">
              {formatCurrency(subtotalEOAmount)}
            </span>
          </div>

          <div className="flex justify-between items-center" data-id="element-165">
            <span className="text-sm font-medium text-neutral-600" data-id="element-166">
              Matched Amount:
            </span>
            <span className="text-sm text-green-600 tabular-nums" data-id="element-167">
              {formatCurrency(matchedAmount)}
            </span>
          </div>

          <div className="h-px bg-neutral-300" data-id="element-168" />

          <div className="flex justify-between items-center bg-blue-50 border border-blue-200 -mx-6 px-6 py-3 rounded" data-id="element-169">
            <span className="text-base font-bold text-neutral-900" data-id="element-170">
              Total Due Amount:
            </span>
            <span className="text-lg font-bold text-blue-700 tabular-nums" data-id="element-171">
              {formatCurrency(totalDueAmount)}
            </span>
          </div>

          {outstandingAmount > 0 && <>
              <div className="h-px bg-neutral-200" data-id="element-172" />
              <div className="flex justify-between items-center" data-id="element-173">
                <span className="text-sm font-semibold text-neutral-700" data-id="element-174">
                  Outstanding Amount:
                </span>
                <span className="text-base font-bold text-red-600 tabular-nums" data-id="element-175">
                  {formatCurrency(outstandingAmount)}
                </span>
              </div>
            </>}
        </div>
      </div>
    </div>;
}